var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroccoli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3996 21.7999C20.5996 20.3999 19.7996 19.0999 19.0996 17.6999C18.4996 16.4999 17.3996 14.9999 17.4996 13.5999C17.4996 12.7999 17.9996 12.1999 18.3996 11.5999C18.5996 11.2999 18.8996 10.8999 18.7996 10.4999C18.5996 9.59989 17.1996 9.39989 16.4996 9.29989C12.1996 8.69989 6.99963 12.4999 8.69963 16.9999C8.29963 17.3999 8.79963 18.1999 9.39963 17.8999C9.49963 17.8999 9.49963 17.8999 9.49963 17.7999C9.59963 17.7999 9.69963 17.6999 9.79963 17.6999C10.3996 17.3999 11.1996 17.0999 11.7996 17.3999C12.3996 17.5999 12.9996 18.1999 13.3996 18.6999C14.1996 19.7999 14.6996 21.1999 15.1996 22.4999C15.5996 23.5999 15.8996 24.0999 17.1996 23.9999C18.5996 23.8999 19.8996 23.3999 21.0996 22.6999C21.3996 22.3999 21.5996 22.0999 21.3996 21.7999Z",
    fill: "#A0DFDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4993 4.19961C20.6993 3.59961 19.7993 3.39961 18.8993 3.59961C18.7993 1.69961 17.1993 0.0996094 15.1993 0.0996094C12.8993 0.0996094 10.8993 1.79961 10.2993 3.89961C9.99932 3.69961 9.69932 3.59961 9.29932 3.49961C7.79932 2.79961 6.09932 2.79961 4.69932 3.89961C3.09932 5.19961 2.89932 7.39961 3.79932 8.99961C2.69932 9.39961 1.99932 10.6996 2.09932 11.9996C2.19932 13.3996 2.99932 14.3996 4.19932 14.9996C3.59932 15.6996 3.49932 16.7996 3.99932 17.6996C4.59932 18.7996 5.89932 19.1996 7.09932 19.2996C8.19932 19.2996 9.69932 19.0996 9.99932 17.7996C10.0993 16.9996 9.79932 16.0996 9.29932 15.3996C10.4993 14.9996 11.1993 13.4996 11.3993 12.0996C12.9993 12.6996 14.5993 11.7996 15.7993 10.5996C17.5993 12.5996 21.6993 10.2996 22.4993 8.19961C22.9993 6.79961 22.6993 5.09961 21.4993 4.19961Z",
    fill: "#32B2A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7988 8.19922C14.8988 8.99922 15.1988 9.89922 15.7988 10.3992C16.3988 10.8992 17.7988 11.5992 19.3988 10.8992",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99922 8.70003C6.99922 8.70003 4.99922 8.20003 3.79922 9.10003C2.49922 10 2.19922 11.8 2.19922 11.8",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3992 12C10.9992 16.1 7.19922 15.1 7.19922 15.1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8984 5.59996C12.1984 4.59996 13.0984 3.79996 14.1984 3.69996C15.2984 3.59996 16.2984 4.29996 16.7984 5.19996",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroccoli);
export default __webpack_public_path__ + "static/media/Broccoli.af4816604681f4956baa9677fdd8c6f1.svg";
export { ForwardRef as ReactComponent };